import { render, staticRenderFns } from "./StyleSwitcherControl.vue?vue&type=template&id=7c36ce90&scoped=true&"
import script from "./StyleSwitcherControl.vue?vue&type=script&lang=js&"
export * from "./StyleSwitcherControl.vue?vue&type=script&lang=js&"
import style0 from "./StyleSwitcherControl.vue?vue&type=style&index=0&id=7c36ce90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c36ce90",
  null
  
)

export default component.exports